module.exports = __webpack_public_path__ + "static/media/appointment.c17ff563.svg";